import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { Button, Modal, Box } from '@mui/material';
import styles from './styles';
import { sendYandexMetrikaEvent } from '../../helpers/yandexMetrika';
import { sendMyTargetEvent } from '../../helpers/myTarget';

function ModalBlock({
  children,
  handleClose,
  ymClickEventType,
  myTargetEventType,
  isOpen = false,
  isFreeForm = false,
  showHeader,
}) {
  if (typeof window === 'undefined' || !window.document) {
    return <></>;
  }
  const handleBackdropClick = (event) => {
    if (window.innerWidth <= 535) {
      event.stopPropagation();
    } else {
      handleClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      sendYandexMetrikaEvent(ymClickEventType || 'formOpen');
      sendMyTargetEvent(myTargetEventType || 'formOpen');
    }
  }, [isOpen]);

  return ReactDOM.createPortal(
    <Modal
      onClose={handleClose}
      open={isOpen}
      componentsProps={{
        backdrop: { onClick: handleBackdropClick },
      }}
      sx={{ zIndex: showHeader ? 4 : 1300 }}
    >
      <Box sx={!isFreeForm ? styles.wrapper : {}}>
        <Button
          onClick={handleClose}
          sx={(theme) => ({
            ...styles.close,
            color: isFreeForm
              ? theme.palette.kit.text.mainInverse
              : theme.palette.kit.text.main,
          })}
        >
          Закрыть
        </Button>

        {children}
      </Box>
    </Modal>,
    document.getElementById('modal'),
  );
}

export default ModalBlock;
